import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import DatePicker from 'react-datepicker';
import moment from 'moment';

const DatePickerField = ({ fieldName, placeholderText }) => {
  return (
    <div className="col-2">
      <Field name={fieldName}>
        {({ input, meta }) => (
          <DatePicker
            {...input}
            selected={input.value ? moment(input.value) : null}
            onChangeRaw={input.onChange}
            dateFormat="MM/DD/YYYY"
            className={`form-input ${meta.submitFailed && meta.error ? 'error' : ''}`}
            placeholderText={placeholderText}
            isClearable
          />
        )}
      </Field>
    </div>
  );
};

DatePickerField.propTypes = {
  fieldName: PropTypes.string.isRequired,
  placeholderText: PropTypes.string.isRequired,
};

export default DatePickerField;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/fields/DatePickerField.jsx